import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  getFormattedTime,
  getUserTimeZone,
} from '../../helpers/DateTime';

const UserProfileTime = ({ profile }) => {
  const intl = useIntl();

  if (!profile) {
    return null;
  }

  const timezone = getUserTimeZone(profile);
  if (!timezone) {
    return null;
  }

  return (
    <li className="user-profile-time" id="user-profile-time">
      <i className="far fa-clock" />
      {intl.formatMessage({ defaultMessage: '{time} local time' }, {
        time: getFormattedTime(moment(), timezone, 'h:mm a'),
      })}
      <UncontrolledTooltip fade={false} target="user-profile-time">
        {profile.timezone?.name}
      </UncontrolledTooltip>
    </li>
  );
};

UserProfileTime.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default UserProfileTime;
